import { Button } from "@mui/material"
import { UseFormReturn } from "react-hook-form"
import { ErrorWithFormProps, LoginFormInputs } from "../hooks"

const ButtonsAndLinks = ({
  formMethods,
  execute,
  error,
}: {
  formMethods: UseFormReturn<LoginFormInputs>
  execute: (data: LoginFormInputs) => Promise<void>
  error: ErrorWithFormProps
}) => {
  return (
    <>
      <Button
        type="submit"
        onClick={formMethods.handleSubmit(execute, error)}
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        disabled={formMethods.formState.isSubmitting}
      >
        サインアップする
      </Button>
      <Button href="/auth/PasswordForget" fullWidth variant="text" sx={{ mb: 4 }}>
        パスワードを忘れた場合はこちら
      </Button>
      <Button href="/auth/signIn" fullWidth variant="outlined" sx={{ mb: 2 }}>
        既にアカウントをお持ちの場合はこちら
      </Button>
    </>
  )
}
export default ButtonsAndLinks
